import { Box, Divider, Typography } from '@mui/material';
import CustomCard from 'components/shared/CustomCard/CustomCard';
import CustomDrawer from 'components/shared/CustomDrawer/CustomDrawer';
import CustomModal from 'components/shared/CustomModal/CustomModal';
import React, { useState } from 'react';
import zeplinColor from 'theme/Color';
import { ClientType } from 'utilities/constants';
import AtheleteForm from '../Forms/AtheleteForm';
import BusinessForm from '../Forms/BusinessForm';
import TalentForm from '../Forms/TalentForm';
import style from './ClientDrawer.module.css';

const ClientDrawer = ({
  drawerState,
  typeSelected,
  setDrawerState,
  getAllClient,
  data,
}: {
  drawerState: boolean;
  typeSelected: string;
  setDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  getAllClient: () => Promise<void>;
  data?: any;
}) => {
  const [selectedItems, setSelectedItems] = useState<{
    salutation: string[];
    agency: any[];
    league: string[];
    team: string[];
    position: string[];
    number: string[];
    status: string[];
    college: string[];
    time: string[];
    client: boolean[];
    type: string[];
    industry: string[];
    category: string[];
    captiv8: any[];
  }>({
    salutation: [],
    agency: data?.parentId
      ? [{ Name: data?.parent, Id: data?.parentID }]
      : data?.agencyID
        ? [{ Name: data?.agency, Id: data?.agencyID }]
        : [''],
    league: data?.league ? [data?.league] : [],
    team: data?.team ? [data?.team] : [],
    position: data?.position ? [data?.position] : [],
    number: [],
    status: data?.status ? [data?.status] : [],
    college: data?.college ? [data?.college] : [],
    time: [],
    client: [],
    type: data?.type ? [data?.type] : [],
    industry: data?.industry ? [data?.industry] : [],
    category: data?.category ? [data?.category] : [],
    captiv8: data?.captiv8Id ? [{ Id: data?.captiv8Id, Name: '' }] : [],
  });

  const [openModal, setOpenModal] = React.useState(false);
  const handleSelection = (item: any, type: string | boolean) => {
    const key = type as keyof typeof selectedItems;
    if (Array.isArray(item)) {
      setSelectedItems((prev) => ({ ...prev, [key]: [...item] }));
    } else if (item?.target?.value) {
      const {
        target: { value },
      } = item;

      setSelectedItems((prev) => ({
        ...prev,
        [key]: typeof value === 'string' ? value.split(',') : value,
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [key]: [item],
      }));
    }
  };
  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setDrawerState(open);
    sessionStorage.removeItem('sf_path');
    sessionStorage.removeItem('sf_redirect');
    sessionStorage.removeItem('sf_edit');
    sessionStorage.removeItem('sf_delete');
  };
  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <CustomDrawer state={drawerState} onClose={onClose(false)}>
      <Box sx={{ width: { xs: '427px', xl: '527px' }, position: 'relative', overflowY: 'scroll' }}>
        <Box
          sx={{
            zIndex: 1000,
            backgroundColor: zeplinColor.Neutral1,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              padding: { xs: '24px 24px 24px 24px', xl: '40px 24px 24px 24px' },
            }}
          >
            {data?.accountId ? (
              <Typography variant='responsiveHeading2'>Edit Client</Typography>
            ) : (
              <Box
                sx={{
                  display: 'flex',
                  gap: '8px',
                  alignItems: 'center',
                }}
              >
                <Typography variant='responsiveHeading2'>New Client: {typeSelected}</Typography>
              </Box>
            )}
            <img
              src={'/assets/close-icon.svg'}
              className={style.icon}
              alt='close'
              style={{ cursor: 'pointer' }}
              onClick={() => setOpenModal(true)}
            />
          </Box>
          <Divider
            component='div'
            sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
          />
          <Box sx={{ padding: '24px 24px 0px 24px' }}>
            {typeSelected === ClientType.Athlete && (
              <AtheleteForm
                handleSelection={handleSelection}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                getAllClient={getAllClient}
                onClose={setDrawerState}
                data={data}
              />
            )}
            {typeSelected === ClientType.Talent && (
              <TalentForm
                handleSelection={handleSelection}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                getAllClient={getAllClient}
                onClose={setDrawerState}
                data={data}
              />
            )}
            {typeSelected === ClientType.Business && (
              <BusinessForm
                handleSelection={handleSelection}
                selectedItems={selectedItems}
                setSelectedItems={setSelectedItems}
                getAllClient={getAllClient}
                onClose={setDrawerState}
                data={data}
              />
            )}
          </Box>
        </Box>
      </Box>
      <CustomModal handleClose={handleClose} open={openModal}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <CustomCard
            styles={{
              borderRadius: '14px',
              padding: { xs: '20px', xl: '24px' },
              backgroundColor: zeplinColor.Neutral1,
              boxShadow: 'rgba(0, 0, 0, 0.15)',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '22px', xl: '32px' },
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Typography variant='responsiveHeading3' color={zeplinColor.BasicBlack}>
                  Discard Changes?
                </Typography>
                <Typography variant='responsiveBody2' color={zeplinColor.BasicBlack}>
                  The client details you entered will be lost if you
                  <br /> close this form now.
                </Typography>
              </Box>
              <Box
                sx={{
                  display: 'flex',

                  gap: { xs: '10px', xl: '16px' },
                }}
              >
                <Box
                  onClick={handleClose}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 20px',
                      backgroundColor: zeplinColor.Neutral1,
                      border: `1px solid ${zeplinColor.BasicBlack}`,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                  >
                    <Typography variant='responsiveButtonMedium' color={zeplinColor.BasicBlack}>
                      Continue Editing
                    </Typography>
                  </CustomCard>
                </Box>
                <Box
                  onClick={onClose(false)}
                  sx={{ flex: 1, display: 'flex', justifyContent: 'center' }}
                >
                  <CustomCard
                    styles={{
                      borderRadius: '14px',
                      padding: '14px 20px',
                      backgroundColor: zeplinColor.Error,
                      cursor: 'pointer',
                      display: 'flex',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                    aria-label='button'
                  >
                    <Typography
                      variant='responsiveButtonMedium'
                      color={zeplinColor.Neutral1}
                      sx={{ whiteSpace: 'nowrap', textAlign: 'center' }}
                    >
                      Yes, Exit
                    </Typography>
                  </CustomCard>
                </Box>
              </Box>
            </Box>
          </CustomCard>
        </Box>
      </CustomModal>
    </CustomDrawer>
  );
};

export default ClientDrawer;
